import { InternalAxiosRequestConfig } from 'axios';
import { applySourceSystemHeader } from '../utils/sourceSystemHeaders';

const AUTH_STORAGE_KEY = 'auth-storage';
const SITE_STORAGE_KEY = 'site-context-storage';
const DEFAULT_BEARER_TOKEN = 'mock-jwt-token';

interface AuthStorageShape {
  state?: {
    token?: string;
    user?: {
      id?: string;
      email?: string;
      name?: string;
      tenantId?: string;
      role?: string;
    };
  };
}

interface SiteStorageShape {
  state?: {
    selectedSite?: {
      id?: number;
      name?: string;
      url?: string;
    };
  };
}

const parseAuthStorage = (): AuthStorageShape | null => {
  const raw = localStorage.getItem(AUTH_STORAGE_KEY);
  if (!raw) return null;
  try {
    return JSON.parse(raw) as AuthStorageShape;
  } catch (error) {
    console.error('Error parsing auth storage:', error);
    return null;
  }
};

const parseSiteStorage = (): SiteStorageShape | null => {
  const raw = localStorage.getItem(SITE_STORAGE_KEY);
  if (!raw) return null;
  try {
    return JSON.parse(raw) as SiteStorageShape;
  } catch (error) {
    console.error('Error parsing site storage:', error);
    return null;
  }
};

const resolveToken = (): string | undefined => {
  const auth = parseAuthStorage();
  return auth?.state?.token || DEFAULT_BEARER_TOKEN;
};

const resolveUserId = (): string | undefined => {
  // Get user ID from auth store
  const auth = parseAuthStorage();
  return auth?.state?.user?.id;
};

const resolveSiteId = (): string | undefined => {
  const site = parseSiteStorage();
  const siteId = site?.state?.selectedSite?.id;
  if (siteId != null) {
    return String(siteId);
  }
  return undefined;
};

const resolveTenantId = (): string | undefined => {
  const auth = parseAuthStorage();
  return auth?.state?.user?.tenantId;
};

export const applyCommonHeaders = (config: InternalAxiosRequestConfig) => {
  const headers = config.headers ?? {};
  applySourceSystemHeader(headers as unknown as Record<string, unknown>);

  const token = resolveToken();
  if (token && !headers.Authorization) {
    headers.Authorization = `Bearer ${token}`;
  }

  // Send user ID instead of tenant ID - backend will look up tenant
  // const userId = resolveUserId();
  // if (userId && !headers['X-User-Id']) {
  //   headers['X-User-Id'] = userId;
  // }

  // Send tenant ID for APIs that require it - use exact case expected by backend
  // const tenantId = resolveTenantId();
  // if (tenantId && !headers['X-Tenant-Id']) {
  //   headers['X-Tenant-Id'] = tenantId;
  // }

  const siteId = resolveSiteId();
  if (siteId && !headers['X-Site-Id']) {
    headers['X-Site-Id'] = siteId;
  }

  config.headers = headers;
  return config;
};
